<template>
  <div>
    <elsa-tree accordion icon-class="tree-icon" :data="treeData" v-on:assign="handleAssign">
      <template v-slot:title="{ node }">
        <span v-bind:class="node.data.options.titleClassArray">
          {{ getTitlel(node.data) }}
        </span>
      </template>
      <template v-slot:subtitle="{ node }">
        <span class="subtitle">{{ node.data.textSubTitle }}</span>
      </template>
      <template v-slot:tags="{ node }">
        <span v-if="node.data.cefr_level" class="tag">{{ node.data.cefr_level }}</span>
      </template>
      <template v-slot:customContent="{ node }">
        <!-- <detail-goals :data="node.data" /> -->
        <detail-goals-all :data="node.data" :orgType="currentOrganizationType"/>
      </template>
    </elsa-tree>
    <add-assignment-wrapper ref="addAssignment" />
  </div>
</template>

<script>
import ElsaTree from "@/components/common/Tree";
import { mappingLevel } from "@/constants/elsaAI";
import { deepClone } from "@/utils/common";
// import DetailGoals from "@/components/scenario/DetailGoals";
import DetailGoalsAll from "@/components/scenario/DetailGoalsAll";
import AddAssignmentWrapper from "@/components/modals/scenario/AddAssignmentWrapper";
import { mapGetters } from "vuex";
import { COMPANY } from "@/constants/organizationType";

export default {
  components: {
    ElsaTree,
    DetailGoalsAll,
    AddAssignmentWrapper,
  },
  props: {
    data: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      treeData: [],
      count: 0,
      k12Topic: [
        {
          id: "NH1",
          label: "JUNIOR HIGH SCHOOL - YEAR 1",
          order: 1,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "NH2",
          label: "JUNIOR HIGH SCHOOL - YEAR 2",
          order: 2,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "NH3",
          label: "JUNIOR HIGH SCHOOL - YEAR 3",
          order: 3,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "bett_brasil",
          label: "Bett Brasil Demo",
          order: 4,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
      ],
      companyTopic: [
        {
          id: "General Business Communication",
          label: "General Business Communication",
          order: 1,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "Customer Support/Customer Service",
          label: "Specialized Knowledge",
          order: 2,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "Advanced Business Communication",
          label: "Advanced Business Communication",
          order: 3,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "!ENT",
          label: "Everyday Situations",
          order: 4,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
      ],
    };
  },
  mounted() {
    this.parseData();
  },
  computed: {
    ...mapGetters("organization", ["currentOrganizationType"]),
  },
  methods: {
    parseData() {
      if (!this.data) {
        return;
      }
      const topic = this.currentOrganizationType == COMPANY ? this.companyTopic : this.k12Topic;
      this.treeData = deepClone(topic);
      let flatScenarios = [];
      this.data.forEach(item => {
        const leaf_node = {
          id: item.id,
          description: item.intro_description,
          featured_image: item.featured_image,
          bot_character_image_url: item.bot_character_image_url,
          objectives: item.objectives,
          options: {
            customContent: true,
          },
        };
        const second_level = {
          id: item.id,
          children: [leaf_node],
          label: item.name,
          cefr_level: mappingLevel[item.level]["en"],
          options: {
            titleClassArray: ["level-1-title"],
            showTags: true,
            showIcon: true,
            iconClassArray: ["elsa-ai-lesson"],
            showListAction: true,
            assignAction: true,
            hideAddAction: true,
            asignActionText: this.currentOrganizationType == COMPANY ? this.$t("homework.scenarios.assign_to_team") : this.$t("homework.scenarios.assign_to_class"),
          },
          tags: item.tags,
        };
        let assigned = false;
        this.treeData.forEach(root => {
          if (second_level.tags && second_level.tags.includes(root.id)) {
            root.children.push(second_level);
            assigned = true;
            second_level.options.iconClassArray.unshift("elsa-level-down");
          } else if (root.id === "!ENT" && second_level.tags && !second_level.tags.includes("ENT")) {
            root.children.push(second_level);
            assigned = true;
            second_level.options.iconClassArray.unshift("elsa-level-down");
          }
        });
        if (!assigned) {
          flatScenarios.push(second_level);
        }
      });
      // Add flat scenarios to treeData
      this.treeData = [...this.treeData, ...flatScenarios];
      this.treeData.forEach(root => {
        // sorting children by order field
        root.children.sort((a, b) => a.order - b.order);
        if (root.children.length > 1) {
          root.textSubTitle = root.children.length + " " + this.$t("common.lessons");
        } else if (root.children.length === 1) {
          root.textSubTitle = root.children.length + " " + this.$t("common.lesson");
        } else {
          // remove root level if no children
          this.treeData = this.treeData.filter(item => item.id !== root.id);
        }
      });
    },
    getTitlel(data) {
      return data.label;
    },
    handleAssign(node) {
      const scenario = {
        id: node.data.id,
        name: node.data.label,
      };
      this.$refs.addAssignment.handleAssignToClassScenario(scenario);
    },
    getIndexMap(object) {
      const keys = Object.keys(object); // Get all keys from the object
      const indexMap = {};
      keys.forEach((key, index) => {
        indexMap[key] = index;
      });
      return indexMap;
    },
  },
  watch: {
    data: {
      handler: function() {
        this.parseData();
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.tag {
  padding: 4px 8px;
  background: #efeff4;
  border-radius: 4px;
  text-transform: uppercase;
  margin-top: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.25px;
  color: #8e8e93;
}

.root-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #121131;
  font-family: sf-pro-text, sans-serif;
}

.level-1-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
}

.level-2-title {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
  font-weight: 400;
}
</style>
